// extracted by mini-css-extract-plugin
export default {"repositoryNameTruncate":"IssuePullRequestDescription-module__repositoryNameTruncate--dTjwn","RelativeTime":"IssuePullRequestDescription-module__RelativeTime--lbeGP"};